import { IGoogleEvent } from "../models";

export const gaEvents: IGoogleEvent[] = [
	// ADVANVED FILTER
	// ADVANVED FILTER
	// ADVANVED FILTER
	{
		"key": "advancefilter_fundpage_feature",
		"event": "Advancefilter-Fundpage-Feature",
		"eventCategory": "advancedFilter",
		"eventAction": "featuredFunds"
	},
	{
		"key": "advancefilter_fundpage_style",
		"event": "Advancefilter-Fundpage-Style",
		"eventCategory": "advancedFilter",
		"eventAction": "style"
	},
	{
		"key": "advancefilter_fundpage_product",
		"event": "Advancefilter-Fundpage-Product",
		"eventCategory": "advancedFilter",
		"eventAction": "product"
	},
	{
		"key": "advancefilter_fundpage_asset",
		"event": "Advancefilter-Fundpage-Asset",
		"eventCategory": "advancedFilter",
		"eventAction": "assetClass"
	},
	{
		"key": "advancefilter_fundpage_share_class",
		"event": "Advancefilter-Fundpage-ShareClass",
		"eventCategory": "advancedFilter",
		"eventAction": "shareClass"
	},
	{
		"key": "advancefilter_fundpage_share_class_type",
		"event": "Advancefilter-Fundpage-ShareClassType",
		"eventCategory": "advancedFilter",
		"eventAction": "shareType"
	},
	{
		"key": "advancefilter_fundpage_region",
		"event": "Advancefilter-Fundpage-Region",
		"eventCategory": "advancedFilter",
		"eventAction": "region"
	},
	{
		"key": "advancefilter_fundpage_currency",
		"event": "Advancefilter-Fundpage-Currency",
		"eventCategory": "advancedFilter",
		"eventAction": "currency"
	},
	{
		"key": "advancefilter_fundpage_reset",
		"event": "Advancefilter-Fundpage-Reset",
		"eventCategory": "advancedFilter",
		"eventAction": "click"
	},
	{
		"key": "scroll_filter_fundpage",
		"event": "Scroll-filter-Fundpage",
		"eventCategory": "advancedFilter",
		"eventAction": "click"
	},
	{
		"key": "scroll_filter_fundpage_morningstar",
		"event": "Scroll-filter-Fundpage_Morningstar",
		"eventCategory": "advancedFilter",
		"eventAction": "morningstar"
	},

	// FUND PRICE AND YIELD
	// FUND PRICE AND YIELD
	// FUND PRICE AND YIELD
	{
		"key": "fund_tab_daily_price",
		"event": "Fund-Tab-Daily Price",
		"eventCategory": "Fund_Tab_Daily Price",
		"eventAction": "click"
	},
	{
		"key": "fund_tab_performance",
		"event": "Fund-Tab-Performance",
		"eventCategory": "Fund_Tab_Performance",
		"eventAction": "click"
	},
	{
		"key": "fund_tab_fund_charges",
		"event": "Fund-Tab-Fund Charges",
		"eventCategory": "Fund_Tab_Fund Charges",
		"eventAction": "click"
	},
	{
		"key": "fund_historic_prices_ppl",
		"event": "Fund-Historic-Prices-PPL",
		"eventAction": "click"
	},
	{
		"key": "fund_widget_yoy",
		"event": "Fund-Widget-YOY",
		"eventAction": "click"
	},
	{
		"key": "fund_widget_calender",
		"event": "Fund-Widget-Calender",
		"eventAction": "click"
	},
	{
		"key": "fund_explorer_sort",
		"event": "Fund-Explorer-Sort",
		"eventAction": "click"
	},
	{
		"key": "fund_widget_visit_fund",
		"event": "Fund-Widget-VisitFund",
		"eventAction": "click"
	},
	{
		"key": "fund_widget_fund_literature",
		"event": "Fund-Widget-FundLiterature",
		"eventAction": "click"
	},
	{
		"key": "addtowatchlist",
		"event": "Add-To-Watchlist",
		"eventAction": "click"
	},
	{
		"key": "removefromwatchlist",
		"event": "Remove-From-Watchlist",
		"eventAction": "click"
	},
	{
		"key": "fundWidgetExpand",
		"event": "Fund-Widget-Expand",
		"eventAction": "click",
		"eventCategory": "Expand All"
	},
	{
		"key": "fundWidgetCollapse",
		"event": "Fund-Widget-collapse",
		"eventAction": "click",
		"eventCategory": "Collapse All"
	},
	{
		"key": "search_filter",
		"event": "Search-Filter",
		"eventAction": "click"
	},
	{
		"key": "fund_download",
		"event": "Fund-Download",
		"eventAction": "click"
	},
	{
		"key": "watchlist",
		"event": "Watchlist",
		"eventAction": "click"
	},

	// FUND PAGE
	// FUND PAGE
	// FUND PAGE
	{
		"key": "fund_page_objective_policy",
		"event": "Fund Page-Objective_Policy",
		"eventCategory": "",
		"eventAction": "Fund Objective and Policy"
	},
	{
		"key": "addtowatchlistFundPage",
		"event": "Add-To-Watchlist-Fund-Page",
		"eventAction": "click"
	},
	{
		"key": "removefromwatchlistFundPage",
		"event": "Remove-From-Watchlist-Fund-Page",
		"eventAction": "click"
	},
	{
		"key": "fund_page_monthly_fund_review",
		"event": "Fund Page-Monthly_Fund_Review",
		"eventCategory": "",
		"eventAction": "Monthly Fund Review"
	},
	{
		"key": "fund_page_updates",
		"event": "Fund Page-Updates",
		"eventCategory": "",
		"eventAction": "Fund news"
	},
	{
		"key": "fund_page_performance_tab_graph",
		"event": "Fund Page-Performance tab",
		"eventCategory": "",
		"eventAction": "Performance Graph",
		"eventLabelTransform": (value) => {
			return value;
		}
	},
	{
		"key": "fund_page_performance_tab",
		"event": "Fund Page-Performance tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_charges_tab",
		"event": "Fund Page-Charges tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_charges_tab",
		"event": "Fund Page-Charges tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_characteristics_tab",
		"event": "Fund page-Characteristics tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_allocation_breakdown_tab",
		"event": "Fund Page-Allocation-Breakdown tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_literature_tab",
		"event": "Fund page-Literature tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_fund_team_tab",
		"event": "Fund page-Fund Team tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_historic_tab_tab",
		"event": "Fund page-Historic tab tab",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_historic_prices",
		"event": "Fund page-Historic_Prices",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_historic_prices",
		"event": "Fund page-Historic_Prices",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_historic_distributions",
		"event": "Fund page-Historic_Distributions",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_historic_distributions",
		"event": "Fund page-Historic_Distributions",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_glossary_cta",
		"event": "Fund page-Glossary_CTA",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "how_to_invest_cta",
		"event": "How to invest_CTA",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "how_to_invest_module",
		"event": "How to invest_module",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "how_to_invest_module",
		"event": "How to invest_module",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_watchlist_cta",
		"event": "Fund Page-Watchlist CTA",
		"eventCategory": "",
		"eventAction": ""
	},
	{
		"key": "fund_page_recently_viewed",
		"event": "Fund Page-Recently_Viewed",
		"eventCategory": "",
		"eventAction": ""
	},
	// MINI FE
	// MINI FE
	// MINI FE
	{
		"key": "find_your_fund_search",
		"event": "Find your fund_search",
		"eventCategory": "",
		"eventAction": "Search"
	},
	{
		"key": "find_your_fund_asset_class",
		"event": "Find your fund_Asset_Class",
		"eventCategory": "",
		"eventAction": "Asset class"
	},
	{
		"key": "find_your_fund_fund_name",
		"event": "Find your fund_Fund_Name",
		"eventCategory": "",
		"eventAction": "Fund Name"
	},
	{
		"key": "find_your_fund_share_class",
		"event": "Find your fund_Share_Class",
		"eventCategory": "",
		"eventAction": "Share Class"
	},
	{
		"key": "find_your_fund_view_all_funds_cta",
		"event": "Find your fund_View all funds_CTA",
		"eventCategory": "View all funds",
		"eventAction": "View all funds"
	}
];


// WEBPACK FOOTER //
// ./src/client/config/google-events.ts